export default __webpack_public_path__ + "static/media/payment.364a9b95.svg";